module.exports = __webpack_public_path__ + "static/media/porcupine.bc2c86af.png";